









































import {Component, Prop, Vue} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';


@Component({
    components: {AmetrasTextFieldTemplate}
})
export default class PromtDialog extends Vue {

    @Prop() width!: number;

    dialog: boolean = false;
    valid: boolean = false;
    input: string = '';
    resolve: any = null;
    reject: any = null;
    message: string = '';
    title: string = '';
    options: any = {
        color: 'primary',
        width: this.width,
        zIndex: 200
    };

    get show() {
        return this.dialog;
    }

    set show(value) {
        this.dialog = value;
        if (!value) {
            this.agree();
        }
    }

    open(title: string, message: string, options?: any) {
        this.dialog = true;
        this.input = '';
        this.title = title;
        this.message = message;
        this.options = Object.assign(this.options, options);
        return new Promise<string>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    agree() {
        this.resolve(this.input);
        this.dialog = false;
    }

}
